(function (factory) {
  typeof define === 'function' && define.amd ? define('index', factory) : factory();
})(function () {
  'use strict';

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ('value' in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  var SectionContainer = /*#__PURE__*/ (function () {
    function SectionContainer() {
      this.constructors = [];
      this.instances = [];
    }
    _createClass(SectionContainer, [
      {
        key: 'register',
        value: function register(type, constructor) {
          var _this = this;
          this.constructors[type] = constructor;
          document
            .querySelectorAll('[data-ac-type='.concat(type, ']'))
            .forEach(function (container) {
              _this._createInstance(container, constructor);
            });
        },
      },
      {
        key: '_createInstance',
        value: function _createInstance(container, constructor) {
          var id = container.getAttribute('data-section-id'),
            type = container.getAttribute('data-ac-type');
          constructor = constructor || this.constructors[type];
          if (typeof constructor === 'undefined') {
            return;
          }
          var instance = Object.assign(new constructor(container), {
            id: id,
            type: type,
            container: container,
          });
          this.instances.push(instance);
        },
      },
    ]);
    return SectionContainer;
  })();

  /*AthariCommerce Modules Here:*/
  var variantImages = /*#__PURE__*/ (function () {
    function variantImages(container) {
      this.element = container;
      this.variantLoader = JSON.parse(this.element.getAttribute('load-variant-images'));
      if (!this.variantLoader) {
        return;
      }
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.delegateBody = new domDelegate.Delegate(document.body);
      this._attachListeners();
      this.slider = this.element;
      var sliderOptions = JSON.parse(this.element.getAttribute('data-flickity-config'));
      this.flickity = new Flickity(this.slider, this.sliderOptions);
      this.hasNavScroller = document.querySelector('.Product__SlideshowNavScroller');
      this.alternateGallery = JSON.parse(this.element.getAttribute('alternate-slider'));
      this.pageDots = this.element.querySelector('.flickity-page-dots');
      this.initSlider();
    }
    _createClass(variantImages, [
      {
        key: 'onUnload',
        value: function onUnload() {},
      },
      {
        key: '_attachListeners',
        value: function _attachListeners() {
          var _this = this;
          window.addEventListener('variant:changed', function (e) {
            _this.resetSlider(e.detail.variant);
            _this.filterSlidesbyID(
              _this.element.querySelector('.flickity-slider'),
              e.detail.variant.id.toString()
            );
          });
        },
      },
      {
        key: 'resetSlider',
        value: function resetSlider(variant) {
          var images = this.element.querySelectorAll('img');
          this.checkImgArray(variant, images);

          if (document.querySelector('.Product__SlideshowNavScroller')) {
            this.checkImgArray(
              variant,
              document.querySelectorAll('.Product__SlideshowNavScroller img'),
              true
            );
          }
        },
      },
      {
        key: 'checkImgArray',
        value: function checkImgArray(variant, containerImageNodeList, isPreviewWrapper) {
          var id = variant.id;
          containerImageNodeList.forEach(function (image) {
            var imageID = parseFloat(image.getAttribute('data-variant-trigger'));

            if (!image.getAttribute('data-variant-trigger')) {
              return;
            }
            if (!(id === imageID)) {
              if (isPreviewWrapper) {
                image.closest('a').style.display = 'none';
                return;
              }
              image.closest('[data-media-id]').style.display = 'none';
            } else {
              if (isPreviewWrapper) {
                image.closest('a').style.display = 'inline-block';
                return;
              }
              image.closest('[data-media-id]').style.display = 'block';
            }
          });
        },
      },
      {
        key: 'initSlider',
        value: function initSlider() {
          this.flkty = new Flickity(this.slider, this.sliderOptions);
          var _this = this;

          this.slides = this.element.querySelectorAll('.Product__SlideItem');
          this.filterSlides(this.slides);
          if (this.hasNavScroller) {
            var navscroller = this.hasNavScroller;
            var navImages = navscroller.querySelectorAll('.Product__SlideshowNavImage');
            navImages.forEach((thumbnail) => {
              thumbnail.addEventListener('click', function () {
                var mediaID = thumbnail.getAttribute('data-media-id');
                _this.selectMediaID(mediaID);
              });
              if (thumbnail.hasAttribute('data-initial-hide')) {
                thumbnail.style.display = 'none';
              }
            });
          }
          return;
        },
      },
      {
        key: 'filterSlides',
        value: function filterSlides(slidesNodes, filterID) {
          var _this = this;
          if (!this.slideNodesArray) {
            this.slideNodesArray = Array.from(slidesNodes);
          }

          var foundVariantID = _this.slideNodesArray
            .find((element) => element.hasAttribute('data-first'))
            .getAttribute('data-variant');
          var newSlides = [];
          this.slideNodesArray.forEach((slide) => {
            if (!slide.hasAttribute('data-variant')) {
              newSlides.push(slide);
            } else {
              if (slide.getAttribute('data-variant') === foundVariantID) {
                newSlides.push(slide);
              }
            }
          });

          this.slideCount = parseInt(newSlides.length);
          _this.element.querySelector('.flickity-slider').innerHTML = '';
          newSlides.forEach((slide, index) => {
            slide.style.left = index + '00%';
            if (_this.alternateGallery) {
              slide.style.left = index * 48 + '%';
            }

            slide.setAttribute('data-image-media-position', index);
            slide.setAttribute('data-media-position', index);
            _this.flickity.append(slide);
          });
          this.flickity = new Flickity(this.slider, this.sliderOptions);
          this.flickity.selectCell(0, true);
          this.flickity.resize();
          this.flickity.reloadCells();
          this.reCalcSlides();
          this.resetDots();
        },
      },
      {
        key: 'filterSlidesbyID',
        value: function filterSlides(slidesNodes, filterID) {
          var _this = this;
          if (!this.slideNodesArray) {
            this.slideNodesArray = Array.from(slidesNodes);
          }

          this.newSlides = [];
          this.slideNodesArray.forEach((slide) => {
            if (!slide.hasAttribute('data-variant')) {
              this.newSlides.push(slide);
            } else {
              if (slide.getAttribute('data-variant') === filterID) {
                this.newSlides.push(slide);
              }
            }
          });
          this.slideCount = parseInt(this.newSlides.length);

          _this.element.querySelector('.flickity-slider').innerHTML = '';
          this.newSlides.forEach((slide, index) => {
            slide.style.left = index + '00%';
            if (_this.alternateGallery && window.innerWidth < 649) {
              slide.style.left = index * 48 + '%';
            }
            slide.setAttribute('data-image-media-position', index);
            slide.setAttribute('data-media-position', index);
            slide.style.display = 'block';
            _this.flickity.append(slide);
          });
          this.flickity.resize();
          this.flickity.reloadCells();
          this.flickity.selectCell(0, true);
          this.reCalcSlides();

          this.resetDots();
        },
      },
      {
        key: 'selectMediaID',
        value: function selectMediaID(idString) {
          var allSlides = this.element.querySelectorAll('.flickity-slider .Product__SlideItem');
          allSlides.forEach((slide) => {
            if (slide.getAttribute('data-media-id') === idString) {
              this.flickity.selectCell(parseInt(slide.getAttribute('data-media-position')), true);
            }
          });
        },
      },
      {
        key: 'resetDots',
        value: function resetDots() {
          var limit = this.slideCount;
          if (!this.pageDots) {
            return;
          }
          this.pageDots.querySelectorAll('.dot').forEach((item, index) => {
            if (index >= limit) {
              item.style.display = 'none';
            } else {
              item.style.display = 'inline-block';
            }
          });
          //var arraylenght =
        },
      },
      {
        key: 'reCalcSlides',
        value: function reCalcSlides() {
          var limit = this.slideCount;
          var _this = this;
          this.element
            .querySelectorAll('.flickity-slider .Product__SlideItem')
            .forEach((item, index) => {
              if (_this.alternateGallery && window.innerWidth < 649) {
                var width = index * 48 + '%';
              } else {
                var width = index * 100 + '%';
              }

              item.style.left = width;
            });
          //var arraylenght =
        },
      },
    ]);

    return variantImages;
  })();

  (function () {
    // First, we register all plugins that are used for all pages
    var sections = new SectionContainer();
    sections.register('variant-images', variantImages);
  })();
});
